export function smartJoin(arr: string[], midSeparator: string = ", ", endSeparator: string = " & "): string {
	if (arr.length === 0) return "";
	if (arr.length === 1) return arr[0];
	if (arr.length === 2) return arr[0] + endSeparator + arr[1];
	return arr.slice(0, -1).join(midSeparator) + endSeparator + arr[arr.length - 1];
}
